import { api } from "../../api/api";
import {
  ADD_CONTENT,
  GET_CONTENT_REQUEST,
  GET_CONTENT_SUCCESS,
  DELETE_CONTENT_REQUEST,
  CHECK_ALL_CONTENT,
  UNCHECK_ALL_CONTENT,
  CHECK_ONE_CONTENT,
  UNCHECK_ONE_CONTENT,
  DELETE_ALL_CONTENT,
  ADD_CONTENT_REQUEST,
  ADD_CONTENT_FAILED,
  DELETE_CONTENT_REQUEST_SUCCESS,
  GET_CONTENT_FAILED,
  CONTENT_FLAG_OFF,
  CONTENT_SCHEDULE_DELETE,
  CONTENT_SCHEDULE_SUCCESS,
  CONTENT_UPDATED,
  CONTENT_RENAMED,
  CLIENT_CONTENT_SUCCESS,
  SET_CONTENT_PAGINATION,
  COUNT_OF_EACH_CONTENT_REQ,
  COUNT_OF_EACH_CONTENT_SUCCESS,
  CLEAR_CONTENT
} from "../constant";

export const clearContent = () => ({
  type: CLEAR_CONTENT,
  payload: ""
});

export const contentFlagOff = () => {
  return async (dispatch) => {
    dispatch({
      type: CONTENT_FLAG_OFF,
      payload: ''
    })
  }
}
export const addContent = (obj) => {
  return async (dispatch) => {
    dispatch({
      type: ADD_CONTENT_REQUEST,
      payload: "",
    });
    try {
      const content = await api.post(`/content/upload`, obj);
      if (content.status === 201) {
        dispatch({
          type: ADD_CONTENT,
          payload: content.data.contents || content.data.content,
        });
      } else {
        dispatch({
          type: ADD_CONTENT_FAILED,
          payload: content?.data || "Upload failed",
        });
      }
    } catch (error) {
      dispatch({
        type: ADD_CONTENT_FAILED,
        payload: error.response?.data || error.message,
      });
    }
  };
};
export const countOfEachContent = (id) => {
  return async (dispatch) => {
    dispatch({
      type: COUNT_OF_EACH_CONTENT_REQ,
      payload: "",
    });
    const { status, data } = await api.get(`/content/countofeachcontent/${id}`);
    if (status == 200)
      dispatch({
        type: COUNT_OF_EACH_CONTENT_SUCCESS,
        payload: data.counts,
      });
  };
};
export const _addFromCanvaTemplate = (obj) => {
  return async (dispatch) => {
    dispatch({
      type: ADD_CONTENT_REQUEST,
      payload: "",
    });
    const content = await api.post(`/content/addFromCanvaTemplate`, obj);
    if (content.status === 201) {
      dispatch({ type: ADD_CONTENT, payload: content.data.content });
    }
  };
};
export const _editToCanvaTemplate = (id, obj) => {
  return async (dispatch) => {
    const { status, data } = await api.patch(`/content/editToCanvaTemplate/${id}`, obj)
    if (status === 201) {
      dispatch({
        type: CONTENT_UPDATED,
        payload: data.content
      })
    }
  }
}
export const getContent = (id, options = {}) => {
  return async (dispatch) => {
    dispatch({
      type: GET_CONTENT_REQUEST,
      payload: "",
    });
    
    const { page = 1, limit = 10, type, search } = options;
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(type && { type }),
      ...(search && { search })
    });
    
    try {
      const content = await api.get(`/content/getcontent/${id}?${params}`);
      
      if (content.status === 200) {
        if (content.data.content.length > -1) {
          dispatch({
            type: GET_CONTENT_SUCCESS,
            payload: {
              content: content.data.content,
              pagination: content.data.pagination
            },
          });
        }
        else {
          dispatch({
            type: GET_CONTENT_FAILED,
            payload: ''
          })
        }
      }
    } catch (error) {
      dispatch({
        type: GET_CONTENT_FAILED,
        payload: error.response?.data || error.message,
      });
    }
  };
};
export const deleteContent = (id) => {
  return async (dispatch) => {
    dispatch({
      type: DELETE_CONTENT_REQUEST,
      payload: "",
    });
    dispatch({
      type: DELETE_CONTENT_REQUEST_SUCCESS,
      payload: id,
    });
    const content = await api.get(`/content/delete/${id}`);
    // if (content.status === 201) {

    // }
  };
};
export const checkAllContent = () => {
  return async (dispatch) => {
    dispatch({
      type: CHECK_ALL_CONTENT,
      payload: "",
    });
  };
};
export const unCheckAllContent = () => {
  return async (dispatch) => {
    dispatch({
      type: UNCHECK_ALL_CONTENT,
      payload: "",
    });
  };
};
export const checkOneContent = (id) => {
  return async (dispatch) => {
    dispatch({
      type: CHECK_ONE_CONTENT,
      payload: id,
    });
  };
};
export const unCheckOneContent = (id) => {
  return async (dispatch) => {
    dispatch({
      type: UNCHECK_ONE_CONTENT,
      payload: id,
    });
  };
};
export const deleteAllContent = (updatedArr, selectedRows) => {
  return async (dispatch) => {
    dispatch({
      type: DELETE_ALL_CONTENT,
      payload: updatedArr,
    });
    await api.post(`/content/multipledelete`, { selectedRows });
  };
};
export const addContentSchedule = (id, obj) => {
  return async (dispatch) => {
    const updated = await api.patch(`/content/schedule/${id}`, obj);
    //console.log('schdule => ',updated)
    if (updated.status === 201) {
      dispatch({
        type: CONTENT_SCHEDULE_SUCCESS,
        payload: updated.data.updated
      })
    }
  }
}
export const deleteContentSchedule = (id) => {
  return async (dispatch) => {
    // console.log('from content delete=>',id)
    const updated = await api.patch(`/content/deletecontentschedule/${id}`);
    // console.log('deleted schdule => ',updated)
    if (updated.status === 201) {
      dispatch({
        type: CONTENT_SCHEDULE_DELETE,
        payload: updated.data.updated
      })
    }
  }
}
export const getClientContent = (id) => {
  return async (dispatch) => {
    const { status, data } = await api.get(`/content/getclientcontents/${id}`);
    if (status == 200) {
      dispatch({
        type: CLIENT_CONTENT_SUCCESS,
        payload: data.content
      })
    }
  }
}
export const contentUpdate = (id, objForUpdateContent) => {
  return async (dispatch) => {
    const { status, data } = await api.patch(`/content/updatecontent/${id}`, objForUpdateContent)
    if (status === 201) {
      dispatch({
        type: CONTENT_UPDATED,
        payload: data.content
      })
    }
  }
}

/** Rename one content item. Throws on failure so the caller can show the error. */
export const renameContent = (id, name) => {
  return async (dispatch) => {
    const { data } = await api.patch(`/content/rename/${id}`, { name });
    dispatch({
      type: CONTENT_RENAMED,
      payload: { id: data.content.id, name: data.content.name }
    })
    return data.content;
  }
}

export const setContentPagination = (pagination) => {
  return {
    type: SET_CONTENT_PAGINATION,
    payload: pagination
  }
}

export const copyTemplate = (templateId, userId) => {
  return async (dispatch) => {
    dispatch({
      type: ADD_CONTENT_REQUEST,
      payload: "",
    });
    try {
      const content = await api.post(`/content/copyTemplate`, { 
        templateId, 
        userId 
      });
      if (content.status === 201) {
        dispatch({ type: ADD_CONTENT, payload: content.data.content });
      }
    } catch (error) {
      console.error('Error copying template:', error);
    }
  };
};
